export const THINK_AGENT = "ProjectAgent";
/** URL path segment for `routeAgentRequest`. useAgent kebabs the class name; raw fetch does not. */
export const THINK_AGENT_URL_SLUG = "project-agent";
export const THINK_MODEL = "@cf/zai-org/glm-5.3-flash";

/**
 * Hostname for `useAgent` (no scheme). Empty / `same-origin` uses the Vite
 * `/agents` proxy on the workbench Worker. Production defaults to same-origin
 * (undefined host). The `127.0.0.1:8789` fallback is local/dev only.
 */
export function thinkAgentHost(): string | undefined {
  const host = import.meta.env.VITE_AGENT_HOST;
  if (host === "" || host === "same-origin") return undefined;
  if (typeof host === "string" && host.length > 0) {
    return host.replace(/^https?:\/\//, "").replace(/\/+$/, "");
  }
  if (import.meta.env.PROD) return undefined;
  return "127.0.0.1:8789";
}

/** Hard-cut: instance name is `proj-{projectId}`. No slug fallback. */
export function thinkAgentName(projectId?: string): string {
  const id = typeof projectId === "string" ? projectId.trim() : "";
  if (id) return `proj-${id}`;
  return "default";
}

const thinkProjectIdByRoute = new Map<string, string>();

/** Keep the last real project id so a loading flicker does not remount useAgent. */
export function rememberThinkProjectId(
  orgSlug?: string,
  projectSlug?: string,
  projectId?: string,
): string {
  const key = `${orgSlug ?? ""}/${projectSlug ?? ""}`;
  const id = typeof projectId === "string" ? projectId.trim() : "";
  if (id) thinkProjectIdByRoute.set(key, id);
  return thinkProjectIdByRoute.get(key) ?? id;
}
